<div class="conn-grid-main create-product">
    <div>
        <div class="settings-tabs-skeleton" *ngIf="isTabsLoading">
            <p-skeleton
                *ngFor="let width of tabSkeletonWidths"
                [width]="width"
                height="2.2rem"
                styleClass="business-tab-skeleton"
            ></p-skeleton>
        </div>

        <ng-container *ngIf="!isTabsLoading">
            <div class="conn-card" *ngIf="!hasInStoreSalesChannel">
                <h2 class="w-title card-title">POS Configuration</h2>
                <p>
                    Please enable the In-Store sales channel to use these settings.
                    <a class="enable-sales-channel-link" (click)="goToSalesChannelSetup()">Enable In-Store Sales</a>.
                </p>
            </div>

            <ng-container *ngIf="hasInStoreSalesChannel">
                <p-tabMenu #tab [model]="items" [activeItem]="activeItem" [scrollable]="true" (click)="onTabItemClick(tab)" (keydown.enter)="onTabItemClick(tab)">
                </p-tabMenu>

                <div *ngIf="activeItem?.label === 'Invoice Configuration'" class="fadeinright animation-duration-200 mt-3">
                    <div class="conn-card">
                        <h2 class="w-title card-title">Invoice Configuration</h2>
                        <div class="conn-grid general-setting-component-container">
                            <app-invoice-configuration [singupBusinessConfig]="false"></app-invoice-configuration>
                        </div>
                    </div>
                </div>

                <div *ngIf="activeItem?.label === 'Printing Configuration'" class="fadeinright animation-duration-200 mt-3">
                    <div class="conn-card">
                        <h2 class="w-title card-title">Printing Configuration</h2>
                        <div class="conn-grid general-setting-component-container">
                            <app-printing-configuration [singupBusinessConfig]="false"></app-printing-configuration>
                        </div>
                    </div>
                </div>

                <div *ngIf="activeItem?.label === 'Cashdrop Configuration'" class="fadeinright animation-duration-200 mt-3">
                    <div class="conn-card">
                        <h2 class="w-title card-title">Cashdrop Configuration</h2>
                        <div class="conn-grid general-setting-component-container">
                            <app-cashdrop-configuration [singupBusinessConfig]="false"></app-cashdrop-configuration>
                        </div>
                    </div>
                </div>

                <div *ngIf="activeItem?.label === 'Cashdrawer Configuration'" class="fadeinright animation-duration-200 mt-3">
                    <div class="conn-card">
                        <h2 class="w-title card-title">Cashdrawer Configuration</h2>
                        <div class="conn-grid general-setting-component-container">
                            <app-cashdrawer-configuration [singupBusinessConfig]="false"></app-cashdrawer-configuration>
                        </div>
                    </div>
                </div>

                <div *ngIf="activeItem?.label === 'Security Configuration'" class="fadeinright animation-duration-200 mt-3">
                    <div class="conn-card">
                        <h2 class="w-title card-title">Security Configuration</h2>
                        <div class="conn-grid general-setting-component-container">
                            <app-security-configuration [singupBusinessConfig]="false"></app-security-configuration>
                        </div>
                    </div>
                </div>

                <div *ngIf="activeItem?.label === 'Secondary Screen Configuration'" class="fadeinright animation-duration-200 mt-3">
                    <div class="conn-card">
                        <h2 class="w-title card-title">Secondary Screen Configuration</h2>
                        <div class="conn-grid general-setting-component-container">
                            <app-secondary-screen-configuration [singupBusinessConfig]="false"></app-secondary-screen-configuration>
                        </div>
                    </div>
                </div>

                <div *ngIf="activeItem?.label === 'Purchase Order'" class="fadeinright animation-duration-200 mt-3">
                    <div class="conn-card">
                        <h2 class="w-title card-title">Purchase Order</h2>
                        <div class="conn-grid general-setting-component-container">
                            <app-purchase-order [singupBusinessConfig]="false"></app-purchase-order>
                        </div>
                    </div>
                </div>

                <div *ngIf="activeItem?.label === 'Time Tracking Configuration'" class="fadeinright animation-duration-200 mt-3">
                    <div class="conn-card">
                        <h2 class="w-title card-title">Time Tracking Configuration</h2>
                        <div class="conn-grid general-setting-component-container">
                            <app-time-tracking-configuration [singupBusinessConfig]="false"></app-time-tracking-configuration>
                        </div>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </div>
</div>
